import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string;

export function initPostHog() {
  if (!POSTHOG_KEY) return;
  posthog.init(POSTHOG_KEY, {
    api_host: 'https://eu.i.posthog.com',
    autocapture: true,
    capture_pageview: true,
  });
}

export function trackEvent(name: string, props?: Record<string, unknown>) {
  posthog.capture(name, props);
}

export function identifyUser(userId: string, traits?: Record<string, unknown>) {
  posthog.identify(userId, traits);
}
